import { render, staticRenderFns } from "./ProviderSideBar.vue?vue&type=template&id=494fac16&"
import script from "./ProviderSideBar.vue?vue&type=script&lang=js&"
export * from "./ProviderSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports